import * as angular from 'angular';

import { AnnouncementFactory } from './announcement.service';
import { AnnouncementTransformer } from './announcement.transformer';

export const announcementModelModule = angular.module('go.models.announcement', [])
	.factory('Announcement', AnnouncementFactory)
	.service('announcementTransformer', AnnouncementTransformer)
	.name;
